module.exports = __webpack_public_path__ + "static/media/Sam,42@2x.9ec20378.png";